import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageService, Message} from "primeng/api";
import {first} from "rxjs/operators";
import {RedefinirSenhaService} from "../../../services/esqueci-senha.service";
import {Router, ActivatedRoute} from "@angular/router";
import {Beneficiario} from "../../../shared/models/beneficiario.model";
import { ThemeService } from '../../../services/theme.service';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'app-recuperar-senha-verificacao',
  templateUrl: './recuperar-senha-verificacao.component.html',
  styleUrls: ['../../login/login.component.scss'],
  providers: [MessageService]
})
export class RecuperarSenhaVerificacaoComponent implements OnInit {

  msgs: Message[] = [];
  form: FormGroup;
  loading: boolean;
  submitted: boolean;
  beneficiario: Beneficiario;
  sucesso = false;

  constructor(private fb: FormBuilder, private messageService: MessageService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private businessService: BusinessService,
    private themeService: ThemeService,
    private redefinirSenhaService: RedefinirSenhaService) {
    this.exibeMensagem();
  }

  ngOnInit() {
    this.form = this.fb.group({
      email: new FormControl('', Validators.required),
      telefone: new FormControl(''),
      token: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),
      dsSenha: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),
      contraSenha: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)])),
    }, {validator: this.checkIfMatchingPasswords('dsSenha', 'contraSenha')});

    this.activatedRouter.queryParams.subscribe((params) => {
      const businessId = this.getBusinessId();
      if (businessId) {
        this.setBusinessId(businessId);
        this.updateTheme(businessId);
      } else {
        this.setBusinessId('1');
        this.updateTheme('1');
      }
    });

    this.exibeMensagem();
  }

  exibeMensagem() {
    if (this.redefinirSenhaService.forgotPasswordUserValue && this.redefinirSenhaService.forgotPasswordUserValue.responseToken) {
      this.beneficiario = this.redefinirSenhaService.forgotPasswordUserValue;
      if (!this.beneficiario.responseToken.statusToken) {
        this.messageService.clear();
        this.messageService.add({severity: 'warn', summary: this.beneficiario.responseToken.body});
      }
    } else {
      this.router.navigate(['./recuperar-senha'], { queryParams: this.codEmpresaUrlParams()});
    }
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      this.messageService.clear();
      let passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordConfirmationInput.value != '' && passwordInput.value !== passwordConfirmationInput.value) {
        this.messageService.add({severity: 'warn', summary: 'As senhas não conferem.'});
        return passwordConfirmationInput.setErrors({notEquivalent: true})
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    }
  }

  onSubmit(value) {
    this.submitted = true;
    this.loading = true;
    this.messageService.clear();

    if (!value.token) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'Informar o código verificador.'});
    } else if (value.dsSenha !== value.contraSenha) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'As senhas não conferem.'});
    } else if (value.dsSenha.length != 6 || value.contraSenha.length != 6) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'A senha deve conter 6 dígitos.'});
    } else {
      this.setBeneficiarioLocalStorage(value.token, value.dsSenha);
      this.redefinirSenhaService.redefinirSenha(this.beneficiario).pipe(first()).subscribe((res) => {
          this.loading = false;
          this.removeBeneficiarioLocalStorage();
          this.messageService.add({
            severity: 'success',
            summary: 'Tudo certo!',
            detail: '<br>Sua nova senha foi cadastrada com sucesso.'
          });
          this.sucesso = true;
        },
        error => {
          this.loading = false;
          if (error == "Unknown Error") {
            this.messageService.add({
              severity: 'error',
              summary: 'Estamos com problemas... Tente novamente em alguns instantes.'
            });
          } else {
            this.messageService.add({severity: 'warn', summary: 'Código verificador inválido.'});
          }
        });
    }
  }

  reenviarToken() {
    this.loading = true;
    this.messageService.clear();
    this.redefinirSenhaService.reenviarToken(this.beneficiario.cdPessoa.toString()).pipe(first()).subscribe((res) => {
        this.loading = false;
        this.messageService.add({severity: 'success', summary: 'Código verificador reenviado com sucesso.'});
      },
      error => {
        this.loading = false;
        if (error == "Unknown Error") {
          this.messageService.add({
            severity: 'error',
            summary: 'Estamos com problemas... Tente novamente em alguns instantes.'
          });
        } else {
          this.messageService.add({severity: 'warn', summary: 'O código de redefinição de senha já foi enviado por sms / e-mail. Verifique!'});
        }
      });
  }

  setBeneficiarioLocalStorage(token: string, dsSenha: string) {
    this.beneficiario.token = token;
    this.beneficiario.cdSenha = dsSenha;
    this.redefinirSenhaService.salvarBeneficiarioLocalStorage(this.beneficiario);
  }

  removeBeneficiarioLocalStorage() {
    this.redefinirSenhaService.removerBeneficiarioLocalStorage();
  }

  setBusinessId(businessId: string) {
    this.businessService.setBusinessId(businessId);
  }

  getBusinessId() {
    return this.businessService.getBusinessId();
  }

  getSelectedTheme() {
    return this.themeService.getSelectedTheme();
  }

  updateTheme(businessId: string) {
    this.themeService.setSelectedTheme(businessId);
    this.themeService.updateTheme(businessId);
  }

  mostrarMsgChatHapvida() {
    return (this.businessService.getBusinessId() === "1");
  }

  codEmpresaUrlParams() {
    return {cod_empresa: this.getBusinessId()};
  }
}
